import { LanguageType } from 'types/enums';
import { useSurveyContext } from '../components/SurveyContext';

export const SurveyMaxAttemptsExceededPage = () => {
	const { language } = useSurveyContext();
	const dictionary = DICTIONARY[language];

	return (
		<>
			<div className="flex flex-col p-8 sm:pt-12 md:pt-20 md:w-[756px] mx-auto">
				<div className="flex flex-col gap-4 sm:gap-6 p-4 sm:p-6 bg-white rounded-lg shadow-normal">
					<h1 className="text-2xl sm:text-4xl font-semibold">{dictionary.title}</h1>
					<p className="text-sm sm:text-lg">{dictionary.description1}</p>
					<p className="text-sm sm:text-lg">{dictionary.description2}</p>
				</div>
			</div>
		</>
	);
};

const DICTIONARY = {
	[LanguageType.English]: {
		title: 'Too many attempts',
		description1: 'You have exceeded the maximum number of allowed attempts.',
		description2: 'Please contact your provider for a new pin code.'
	},
	[LanguageType.Norwegian]: {
		title: 'For mange forsøk',
		description1: 'Du har overskredet maksimalt antall tillatte forsøk.',
		description2: 'Vennligst be om en ny pin-kode.'
	}
};
